import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FunktionsbereichChecklistenAufgabenPage } from './funktionsbereich-checklisten-aufgaben.page';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {FunktionsbereichChecklistenAufgabenPageUiEffects} from './funktionsbereich-checklisten-aufgaben.effects.ui';
import {ComponentsModule} from '../../../../sopi/components/components.module';
import {reducers} from './funktionsbereich-checklisten-aufgaben.reducer';
import {DocumentViewer} from '@ionic-native/document-viewer/ngx';
import {DocumentService} from '@orga-app/providers/document.service';
import {
  VeranstaltungenChecklisteFreigebenEffects,
  VeranstaltungenFunktionsbereichChecklistenAufgabenEffects
} from '../../../../client-ngrx/veranstaltungen';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {PipesSharedModule} from '../../../shared/pipes/pipes-shared.module';

const routes: Routes = [
/*  {
    path: '',
    component: FunktionsbereichChecklistenAufgabenPage
  }*/
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('FunktionsbereichChecklistenAufgabenPage', reducers),
        EffectsModule.forFeature([
            FunktionsbereichChecklistenAufgabenPageUiEffects,
            VeranstaltungenFunktionsbereichChecklistenAufgabenEffects,
            VeranstaltungenChecklisteFreigebenEffects
        ]),
        ComponentsModule,
        SopiComponentsModule.forRoot(),
        PipesSharedModule,
    ],
    declarations: [FunktionsbereichChecklistenAufgabenPage],
    exports: [
        FunktionsbereichChecklistenAufgabenPage
    ],
    providers: [
        DocumentService,
        DocumentViewer
    ]
})
export class FunktionsbereichChecklistenAufgabenPageModule {}
